const UserGroup = {
  Admin: "Admin",
};

export const AuthorizedUserGroups = [UserGroup.Admin];
